import React from 'react'

import Svg, { Path, Rect } from 'react-native-svg'

const HindiLanguage = ({ ...props }) => {
  return (
    <Svg
      width={36}
      height={36}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect x={0.5} y={0.5} width={35} height={35} rx={17.5} fill="#fff" />
      <Path
        d="M12 13.5v1.588H7.725v1.405c.264-.146.553-.219.868-.219.684 0 1.258.325 1.72.974.463.65.695 1.327.695 2.033 0 .739-.218 1.473-.653 2.203l-1.193-1.25c.522-.772.784-1.43.784-1.976 0-.541-.215-.812-.646-.812-.254 0-.78.27-1.575.812V22.5h-.284l-1.395-1.482v-1.603c-.579.363-1.046.544-1.402.544-.495 0-.944-.247-1.346-.741-.403-.494-.604-1.104-.604-1.829 0-1.049.47-1.574 1.409-1.574.583 0 1.23.318 1.943.953v-1.68H2V13.5h10Zm-5.954 4.066v-.134c-.407-.174-.766-.261-1.076-.261-.356 0-.682.082-.978.247-.296.164-.444.4-.444.706 0 .164.06.305.18.423.125.113.278.17.458.17.44 0 1.06-.384 1.86-1.151Z"
        fill="#B7C6DE"
      />
      <Path
        d="M23 13.5v1.59h-1.535v7.41h-.276l-.91-1.004c-.624.443-1.234.665-1.831.665-1.15 0-2.265-.597-3.347-1.789-1.082-1.197-1.623-2.244-1.623-3.14 0-.574.157-.862.472-.862.148 0 .3.09.457.269a13.68 13.68 0 0 0 .108-1.548H13V13.5h10Zm-3.158 1.59h-4.169c0 1.617-.249 2.92-.747 3.91.889 1.4 1.85 2.1 2.882 2.1.642 0 1.32-.285 2.034-.855V19.22a2.96 2.96 0 0 1-.869.593c-.341.156-.633.234-.875.234-.427 0-.849-.255-1.266-.764-.413-.509-.62-1.07-.62-1.683 0-.513.186-.947.559-1.3.373-.359.83-.538 1.374-.538.467 0 1.032.337 1.697 1.011v-1.682Zm0 2.461v-.318a3.04 3.04 0 0 0-1.037-.198c-.386 0-.775.122-1.165.368-.39.24-.586.504-.586.791 0 .335.233.502.7.502.36 0 .763-.11 1.212-.332.454-.221.746-.492.876-.813Z"
        fill="#8093B7"
      />
      <Path
        d="M34 13.5v1.59h-1.855v7.41h-.301L30.2 21.001v-5.91h-2.652l.317 2.58c.087.703.13 1.146.13 1.33 0 .82-.282 1.23-.846 1.23-.461 0-1.017-.406-1.668-1.216-.646-.811-.968-1.42-.968-1.825 0-.221.184-.332.553-.332.076 0 .195.007.358.021.157.015.271.022.342.022.255 0 .382-.111.382-.333v-1.477H24V13.5h10Z"
        fill="#9BADCF"
      />
      <Rect x={0.5} y={0.5} width={35} height={35} rx={17.5} stroke="#D1D9E9" />
    </Svg>
  )
}

export default HindiLanguage
